import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TypedRoute } from '@shared/utils';
import { LoggedInLayoutResolve } from '@shared/models';
import { ArivoDialogComponent } from '@shared/components/ui-elements';
import { DialogService } from '@shared/services';
import { CoreDataService, FeatureFlagService, WarningData } from '@core/services';
import { take } from 'rxjs';

@Component({
  selector: 'app-logged-in-layout',
  templateUrl: './logged-in-layout.component.html',
  styleUrl: './logged-in-layout.component.scss',
})
export class LoggedInLayoutComponent implements OnInit {
  @ViewChild('homeScreenDialog') homeScreenDialog!: ArivoDialogComponent;
  redirectByPaymentVerification: boolean = false;
  isOnboardingRoute: boolean = false;
  isUserDataRoute: boolean = false;
  externalBillingEnabled: boolean = false;

  constructor(
    @Inject(ActivatedRoute) private route: TypedRoute<LoggedInLayoutResolve>,
    private router: Router,
    private dialogService: DialogService,
    private coreDataService: CoreDataService,
    private featureFlagService: FeatureFlagService,
  ) {}

  ngOnInit() {
    this.externalBillingEnabled = this.featureFlagService.getFeatureFlag('enable_external_billing');
    this.route.data.subscribe({
      next: (data: LoggedInLayoutResolve) => {
        this.redirectByPaymentVerification = !!this.route.snapshot.queryParams['redirectResult'];
        this.isOnboardingRoute = this.router.url.includes('/onboarding');
        this.isUserDataRoute = this.router.url.includes('/data');

        this.coreDataService.warningData.pipe(take(1)).subscribe({
          next: (warningData: WarningData) => {
            if (!this.redirectByPaymentVerification) {
              if (warningData.banStatus) {
                this.handleBanStatus(warningData);
              } else {
                this.handleWarningData(warningData);
              }
            }
          },
        });
        this.coreDataService.setCoreData(data.core_data);
      },
    });
  }

  handleBanStatus(warningData: WarningData) {
    if (warningData.banStatus!.active) {
      if (warningData.banStatus!.reason === 'due_payment') {
        this.dialogService.showPaymentFailedDialog();
      } else if (warningData.banStatus!.reason === 'missing_payment_method') {
        this.dialogService.showMissingPaymentMethodBannedDialog();
      } else if (warningData.banStatus!.reason === 'other') {
        this.dialogService.showBannedDialog();
      }
    } else {
      this.dialogService.showBanImminentDialog();
    }
  }

  handleWarningData(warningData: WarningData) {
    if (!this.isOnboardingRoute && !this.externalBillingEnabled) {
      if (warningData.paymentMissing && warningData.customerAddressMissing) {
        this.dialogService.showFinishRegistrationReminderDialog();
      } else if (warningData.paymentMissing) {
        this.dialogService.showPaymentMethodReminderDialog();
      } else if (warningData.customerAddressMissing && !this.isUserDataRoute) {
        this.dialogService.showCustomerAddressReminderDialog();
      }
    }
  }
}
